import { render, staticRenderFns } from "./BubbleTabs.vue?vue&type=template&id=5d4ab479&scoped=true&"
import script from "./BubbleTabs.vue?vue&type=script&lang=ts&"
export * from "./BubbleTabs.vue?vue&type=script&lang=ts&"
import style0 from "./BubbleTabs.vue?vue&type=style&index=0&id=5d4ab479&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ab479",
  null
  
)

export default component.exports